import * as _ from "lodash";
import {ChangePasswordForm as Validator} from '../../utils/validators';

export const SET_PASSWORD_ERROR = 'SET_PASSWORD_ERROR',
    CHANGE_PASSWORD = 'CHANGE_PASSWORD',
    RESET_CHANGE_PASSWORD = 'RESET_CHANGE_PASSWORD';

interface Action {
    payload: any,
    type: string,
    field: string,
    value?: any,
    validate: boolean
}

interface Form {
    valid: boolean,
    changed: boolean
    data: {
        [key: string]: {
            required: boolean,
            added: boolean,
            value: any,
            error: any,
            dirty: boolean,
            errTypes?: any
        },
    }
}

const initialState: Form = {
    valid: false,
    data: {
        oldPassword: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
        newPassword: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
        confirmPassword: {
            required: true,
            added: false,
            value: null,
            error: null,
            dirty: false,
            errTypes: {
                u: false,
                l: false,
                n: false,
                min: false
            }
        },
    },
    changed: false,
};

const baseState = _.cloneDeep(initialState);

const ChangePasswordForm = (state = initialState, action: Action) => {
    switch (action.type) {
        case CHANGE_PASSWORD:
            console.log(action)
            return Validator({...state.data}, action);
        case SET_PASSWORD_ERROR:
            const newState = _.cloneDeep(state),
                errType = action.payload.errType;
            newState.data[errType].error = action.payload.message;
            return {
                ...newState
            };
        case RESET_CHANGE_PASSWORD:
            return _.cloneDeep(baseState);
        default:
            return state;
    }
};

export default ChangePasswordForm;
